import { AppShell, Container, Group, Title } from '@mantine/core';
import { Music } from 'lucide-react';

export function Layout({ children }) {
    return (
        <AppShell
            header={{ height: 60 }}
            padding="md"
        >
            <AppShell.Header>
                <Container size="lg" h="100%">
                    <Group h="100%" px="md" justify="space-between">
                        <Group>
                            <Music size={28} color="#be4bdb" strokeWidth={2.5} />
                            <Title order={3} style={{
                                background: 'linear-gradient(45deg, #be4bdb, #228be6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent'
                            }}>
                                HighNote
                            </Title>
                        </Group>
                        {/* Future Navigation Items can go here */}
                    </Group>
                </Container>
            </AppShell.Header>

            <AppShell.Main>
                <Container size="lg">
                    {children}
                </Container>
            </AppShell.Main>
        </AppShell>
    );
}
